// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"78":"assessment","174":"summary","177":"home","535":"login","767":"details","845":"profile","915":"review","983":"report"}[chunkId] + "." + {"78":"49b92a17","174":"b17889c4","177":"3024e0b1","535":"41ad5c69","767":"35c28abb","845":"ba8c7728","915":"fcf404c2","983":"19715a7f"}[chunkId] + ".css";
};